/**
 * Extracts the route name from the current URL
 * @returns The route name (e.g., 'home', 'about', 'services') or 'home' for root
 */
export function getRouteNameFromUrl(): string {
  if (typeof window === 'undefined') return 'home';
  
  const pathname = window.location.pathname;
  
  // Remove leading slash and get the first segment
  const route = pathname.replace(/^\/+/, '').split('/')[0];
  
  // Return 'home' for empty route (root path)
  return route || 'home';
}

/**
 * Generates a context-aware message based on the current page
 * @param routeName The route name extracted from URL
 * @returns A contextual message describing user interest
 */
export function generateContextualMessage(routeName: string): string {
  const pageMessages: Record<string, string> = {
    'home': 'I am interested in learning more about BrainsieTech\'s AI-powered solutions and services.',
    'about': 'I would like to know more about BrainsieTech\'s team and company background.',
    'services': 'I am interested in exploring BrainsieTech\'s AI and technology services.',
    'blog': 'I found your blog content interesting and would like to discuss potential collaboration.',
    'contact': 'I would like to get in touch to discuss my business requirements.',
    'case-studies': 'I am interested in learning more about your successful project implementations.',
    'careers': 'I am interested in career opportunities at BrainsieTech.',
    'pricing': 'I would like to discuss pricing options for your services.',
    'products': 'I am interested in learning more about your AI products and solutions.'
  };

  return pageMessages[routeName] || `I am interested in learning more about BrainsieTech's offerings from the ${routeName} page.`;
}
